import { Injectable } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AutologoutConfirmDialogComponent } from '../views/shared/autologout-confirm-dialog/autologout-confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AutologoutConfirmDialogService {

   constructor(private dialog: MatDialog) {}
 
   openConfirmDialog(message: string): MatDialogRef<AutologoutConfirmDialogComponent> {
     return this.dialog.open(AutologoutConfirmDialogComponent, {
       data: { message },
       disableClose: true
     });
   }
}
